import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-phone\"><g clip-path=\"url(#clip0_37_4358)\"><path d=\"m17.486 12.72-3.937-1.688a.843.843 0 0 0-.984.242l-1.744 2.131a13.031 13.031 0 0 1-6.23-6.23l2.13-1.743a.842.842 0 0 0 .243-.984L5.277.51A.85.85 0 0 0 4.31.021L.654.865A.844.844 0 0 0 0 1.687C0 10.705 7.309 18 16.313 18a.844.844 0 0 0 .822-.654l.844-3.656a.853.853 0 0 0-.493-.97Z\" fill=\"currentColor\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol